import { EquipSlot } from "@/domains/inventory/constants/equipSlot";
import { ItemType } from "@/domains/inventory/constants/itemType";

export function determineEquipmentSlotType(itemType: ItemType): EquipSlot | null {
  switch (itemType) {
    case ItemType.Hat:
      return EquipSlot.Hat;
    case ItemType.Mask:
      return EquipSlot.Mask;
    case ItemType.Glasses:
      return EquipSlot.Glasses;
    case ItemType.Ears:
      return EquipSlot.Ears;
    case ItemType.Watches:
      return EquipSlot.Watches;
    case ItemType.Bracelets:
      return EquipSlot.Bracelets;
    case ItemType.Tops:
      return EquipSlot.Tops;
    case ItemType.Shoes:
      return EquipSlot.Shoes;
    case ItemType.Legs:
      return EquipSlot.Legs;
    case ItemType.Armor:
      return EquipSlot.BodyArmors;
    case ItemType.Bag:
      return EquipSlot.Bags;
    case ItemType.Pistol:
    case ItemType.Shotgun:
    case ItemType.SMG:
    case ItemType.Rifle:
    case ItemType.Sniper:
    case ItemType.Heavy:
    case ItemType.Melee:
    case ItemType.MachineGuns:
    case ItemType.Canister:
      return EquipSlot.Hands;
    default:
      return null;
  }
}
